module.exports = __webpack_public_path__ + "img/ring_KITO_HMM.f8405c2c.png";